import { Component, Input, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ServedByOptionType } from '@zero/self-service/domain';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'saving-plans-savings-plan-served-by-modal',
  imports: [TranslocoPipe, ButtonComponent, ModalComponent],
  templateUrl: './savings-plan-served-by-modal.component.html',
})
export class SavingsPlanServedByModalComponent {
  public readonly modal = inject(NgbActiveModal);

  @Input() public type: ServedByOptionType;
}
